const c = "en-gb", u = "-", A = (e, t) => t && e !== t, i = (e, t = c) => t && e === t ? {
  filter: {
    languages_locale: {
      _eq: e
    }
  }
} : {
  sort: "-languages_locale",
  filter: {
    languages_locale: {
      _in: [t, e]
    }
  }
}, _ = (e) => {
  const { filter: t, sort: s } = i(e, c);
  return {
    translations: {
      ...s && { _sort: s },
      _filter: t
    }
  };
}, y = (e, t) => e.split(".").reduceRight((l, n) => ({ [n]: l }), t), f = (e) => {
  const t = {};
  for (const [s, l] of Object.entries(e)) {
    const n = s.split(".");
    let r = t;
    for (const o of n.slice(0, -1))
      (typeof r[o] != "object" || r[o] === null || Array.isArray(r[o])) && (r[o] = {}), r = r[o];
    const a = n[n.length - 1];
    (typeof r[a] != "object" || r[a] === null || Array.isArray(r[a])) && (r[a] = {}), r[a]._sort = l;
  }
  return t;
};
export {
  c as FALLBACK_EN_LOCALE,
  u as LANGUAGE_LOCALE_SEPARATOR,
  _ as createDeepTranslationsFilter,
  y as createFiltersOnPath,
  i as createTranslationsParams,
  A as currentLocaleMatchFallback,
  f as expandDeepSorts
};
